import { PortalThemeColors } from '@nx-frontend/shared/types';

interface ApplyThemeVariantsProps {
  path: string;
  theme: PortalThemeColors;
}

export const applyThemeVariants = ({ path, theme }: ApplyThemeVariantsProps): PortalThemeColors => {
  if (theme.variants) {
    for (const variant of theme.variants) {
      if (variant.rules.path === path || variant.rules.notPath !== path) {
        return { ...theme, ...variant.modify, variants: undefined };
      }
    }
  }
  return theme;
};
